module.exports = __webpack_public_path__ + "s.no1.f43bdff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s.no1.jpg
// module id = U1H3
// module chunks = 0